module.exports = __webpack_public_path__ + "img/Group (17).c955ec6b.svg";